module.exports = __webpack_public_path__ + "site/img/15.76e24c38.jpg";